// extracted by mini-css-extract-plugin
export default {"childMenuItem":"child-menu-item_childMenuItem__KmbFy","text":"child-menu-item_text__WMnvA","active":"child-menu-item_active__Qkci+"};